import { LayaGL } from "../../layagl/LayaGL";
import { NotReadableError } from "../../utils/Error";
export class VertexBuffer3D {
    get vertexDeclaration() {
        return this._deviceBuffer.vertexDeclaration;
    }
    set vertexDeclaration(value) {
        this._deviceBuffer.vertexDeclaration = value;
    }
    get instanceBuffer() {
        return this._deviceBuffer.instanceBuffer;
    }
    set instanceBuffer(value) {
        this._deviceBuffer.instanceBuffer = value;
    }
    get canRead() {
        return this._canRead;
    }
    constructor(byteLength, bufferUsage, canRead = false) {
        this._float32Reader = null;
        this._deviceBuffer = LayaGL.renderDeviceFactory.createVertexBuffer(bufferUsage);
        this._canRead = canRead;
        this._byteLength = byteLength;
        this._deviceBuffer.setDataLength(byteLength);
        this.bufferUsage = bufferUsage;
        if (this._canRead) {
            this._buffer = new Uint8Array(byteLength);
            this._float32Reader = new Float32Array(this._buffer.buffer);
        }
    }
    setData(buffer, bufferOffset = 0, dataStartIndex = 0, dataCount = Number.MAX_SAFE_INTEGER) {
        this._deviceBuffer.setData(buffer, bufferOffset, dataStartIndex, dataCount);
        var needSubData = dataStartIndex !== 0 || dataCount !== Number.MAX_SAFE_INTEGER;
        if (needSubData) {
            var subData = new Uint8Array(buffer, dataStartIndex, dataCount);
            if (this._canRead)
                this._buffer.set(subData, bufferOffset);
        }
        else {
            if (this._canRead)
                this._buffer.set(new Uint8Array(buffer), bufferOffset);
        }
    }
    getUint8Data() {
        if (this._canRead)
            return this._buffer;
        else
            throw new NotReadableError();
    }
    getFloat32Data() {
        if (this._canRead)
            return this._float32Reader;
        else
            throw new NotReadableError();
    }
    markAsUnreadbale() {
        this._canRead = false;
        this._buffer = null;
        this._float32Reader = null;
    }
    destroy() {
        this._deviceBuffer.destroy();
        this._buffer = null;
        this._float32Reader = null;
        this._byteLength = 0;
    }
}
